<template>
    <div class="all">
        <div>
            <div class="tp1">
                <div>
                    <b-img :src="require('@/assets/supportp1.png')" class="tp1-image" />
                </div>  
            </div>

            <div class="tp2">
                <div class="tp2_left"></div>
                <div class="tp2_mid">
                    <div class="tp2_mid_left">
                        <div class="tp2_mid_left_left">
                            <b-img :src="require('@/assets/supportp2.png')" class="p2" />
                        </div>
                        <div class="tp2_mid_left_right">
                            <div class="tp2_mid_left_right_1">Tel</div>
                            <div class="tp2_mid_left_right_2">
                                <div class="tp2_mid_left_right_2_icon"><b-img :src="require('@/assets/supportp3.png')" class="p3" /></div>
                                <div class="tp2_mid_left_right_2_txt">+86-0571-87775642</div>
                            </div>
                        </div>
                    </div>
                    <div class="tp2_mid_right">
                        <div class="tp2_mid_right_left">
                            <b-img :src="require('@/assets/supportp4.png')" class="p4" />
                        </div>
                        <div class="tp2_mid_right_right">
                            <div class="tp2_mid_right_right_1">E-mail</div>
                            <div class="tp2_mid_right_right_2">
                                <div class="tp2_mid_right_right_2_icon"><b-img :src="require('@/assets/supportp5.png')" class="p5" /></div>
                                <div class="tp2_mid_right_right_2_txt">marketing1@aconlab.com.cn</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tp2_right"></div>
            </div>

            <div class="tp3">
                <div class="tp3_left"></div>
                <div class="tp3_mid">
                    <div class="tp3_mid_1">Office Address</div>
                    <div class="tp3_mid_2">
                    <div 
                        class="tp3_mid_2_cn" 
                        :class="{ active: selectedCountry === 'cn' }" 
                        @click="selectCountry('cn')">China</div>
                    <div 
                        class="tp3_mid_2_us" 
                        :class="{ active: selectedCountry === 'us' }" 
                        @click="selectCountry('us')">United States</div>
                    </div>
                    <div class="tp3_mid_3">
                    <div v-show="selectedCountry === 'cn'" class="tp3_mid_3_left">
                        <!-- 中国的内容 -->
                        <div class="cn_left">
                            <div>
                                <b-img :src="require('@/assets/support_cn.png')" class="tp3_cn" />
                            </div>  
                        </div>
                        <div class="cn_right">
                            <div class="cn_right_1">ACON Biotech (HangZhou) Co., Ltd.</div>
                            <div class="cn_right_2">
                                <div class="cn_right_2_icon">
                                    <div>
                                        <b-img :src="require('@/assets/support_cnusicon.png')" class="tp3_cnusicon" />
                                    </div> 
                                </div>
                                <div class="cn_right_2_txt">
                                    <div class="cn_right_2_txt_1">Address</div>
                                    <div class="cn_right_2_txt_2">No. 210 Zhenzhong Road, Aicheng Industrial Park,West Lake District, Hangzhou, 310030, Zhejiang, P.R. China</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="selectedCountry === 'us'" class="tp3_mid_3_right">
                        <!-- 美国的内容 -->
                        <div class="us_left">
                            <div>
                                <b-img :src="require('@/assets/support_us.png')" class="tp3_us" />
                            </div>  
                        </div>
                        <div class="us_right">
                            <div class="us_right_1">ACON Laboratories, Inc.</div>
                            <div class="us_right_2">
                                <div class="us_right_2_icon">
                                    <div>
                                        <b-img :src="require('@/assets/support_cnusicon.png')" class="tp3_cnusicon" />
                                    </div> 
                                </div>
                                <div class="us_right_2_txt">
                                    <div class="us_right_2_txt_1">Address</div>
                                    <div class="us_right_2_txt_2">5850 Oberlin Drive, #340, San Diego,CA 92121 U.S.A</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="tp3_right"></div>
            </div>
            
        </div>
    </div>
</template>
  
  <script>
  export default {
    name: 'SupportPage',
    data() {
    return {
      selectedCountry: 'cn' // 初始选择中国
    };
  },
  methods: {
    selectCountry(country) {
      this.selectedCountry = country;
    }
  },
    mounted() {
  },
  }
  </script>
  
  <style scoped>
  .all{
    min-width: 1200px;
  }

  .tp1 {
  position: relative;
    width: 100%;
    overflow: hidden;
  }
  .tp1-image{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .tp2{
    display: grid;
    grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
    gap: 0; /* 去掉列间距 */
    margin-top: 40px;
    height: 456px;
  }
  .tp2_mid{
    display: grid;
    grid-template-columns: 490px 584px;
    gap: 0; /* 去掉列间距 */
    justify-content: center;
    align-items: center;
    justify-items: center;
  }
  .tp2_mid_left, 
  .tp2_mid_right,
  .tp2_mid_left_right_2,
  .tp2_mid_right_right_2 {
    display: flex;
  }

  .tp2_mid_left {
    display: flex;
    align-items: center;
    height: 216px;
    width: 490px;
    box-shadow: 0px 4px 24px 0px #00000014;
    margin-right: 40px; 
}
.tp2_mid_right {
    display: flex;
    align-items: center;
    height: 216px;
    width: 584px;
    box-shadow: 0px 4px 24px 0px #00000014; 
}


.p2,
.p4{
    margin-left: 56px;
    margin-right: 32px;
    width: 88px;
    height: 88px;
}
.tp2_mid_left_right_1,
.tp2_mid_right_right_1{
    font-family: Arial;
font-size: 32px;
font-weight: 700;
line-height: 40px;
text-align: left;
color: #333333;
margin-bottom: 16px;
}
.tp2_mid_left_right_2_icon,
.tp2_mid_right_right_2_icon{
    margin-right:8px ;
    width: 32px;
    height: 32px;
}
.tp2_mid_left_right_2_txt,
.tp2_mid_right_right_2_txt {
    font-family: Arial;
    font-size: 24px;
    font-weight: 400;
    line-height: 32px;
    text-align: left;
    color: #007EFF;
}

.tp3 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */
  margin-top: 40px;
  height: 800px;
  background-image: url('@/assets/supporttp3bg.png'); /* 添加背景图 */
  background-size: cover; /* 使背景图覆盖整个区域 */
  background-position: center; /* 使背景图居中 */
}
.tp3_mid {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.tp3_mid_1 {
    font-family: Arial;
font-size: 36px;
font-weight: 700;
line-height: 42px;
margin-bottom: 56px;
}
.tp3_mid_2 {
  display: flex;
  justify-content: center;
  font-family: Arial;
font-size: 20px;
font-weight: 400;
line-height: 28px;
color: #333333;
  margin-bottom: 68px;
}
.tp3_mid_2_cn,
.tp3_mid_2_us {
  margin: 0 10px;
  cursor: pointer;
  padding: 10px 20px;
  border-radius: 4px;
  transition: background-color 0.3s ease, color 0.3s ease;
}
.tp3_mid_2_cn.active,
.tp3_mid_2_us.active {
  background-color: #007bff;
  color: white;
}
.tp3_mid_3 {
  display: flex;
  justify-content: center;
  width: 100%;
}
.tp3_mid_3_left,
.tp3_mid_3_right {
  width: 100%;
  transition: opacity 0.3s ease;
  display: flex;
    background-color: #ffffff;
}
.cn_right,
.us_right {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.cn_right_1,
.us_right_1 {
    font-family: Arial;
font-size: 24px;
font-weight: 700;
line-height: 48px;
margin-bottom: 32px;
margin-left: 32px;
}
.cn_right_2,
.us_right_2 {
    display: flex;
    margin-left: 32px;
}
.cn_right_2_txt_1,
.us_right_2_txt_1 {
    font-family: Arial;
font-size: 20px;
font-weight: 400;
line-height: 32px;
color: #666666;
margin-left: 16px;
}
.cn_right_2_txt_2,
.us_right_2_txt_2 {
    font-family: Arial;
font-size: 20px;
font-weight: 400;
line-height: 32px;
color: #333333;
margin-left: 16px;
margin-top: 16px;
}
  </style>